const SALE_DISABLED = `${process.env.REACT_APP_DISABLED_SALE}` === 'true';
export default SALE_DISABLED;